module.exports = __webpack_public_path__ + "static/media/living room-01.4dc096e4.jpg";